var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.appointmentCount)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipConfig),expression:"tooltipConfig"}],staticClass:"appointment-count"},[_vm._v("\n    "+_vm._s(_vm.appointmentCount)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }